import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ScoreBySenior from "./ScoreBySenior";
import {fetchSelfScorecardBySenior} from "services/redux/brandActivtion/meetings/action";

const mapStateToProps = (state) => ({
    getUserScoreBySenior: state.baMeetingReducer.getUserScoreBySenior
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            fetchSelfScorecardBySenior,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ScoreBySenior);
